<template>
  <div v-if="route.name !== 'works'" class="fixed top-0 z-[11] w-full">
    <div class="container-1 w-full mx-auto flex items-center justify-between">
      <a
href="/" class="flex-shrink-0" aria-label="Ellie Motion: Creative Video Production House in Singapore" :class="[{'text-ellie-yellow': route.name === 'get-in-touch'}]" @mouseenter="toggleHover(true)"
        @mouseleave="toggleHover(false)"
      >
        <MainLogo class="w-full" />
      </a>
      <div class="flex items-center gap-2 shadow-md rounded-full border border-black border-opacity-5">
        <div v-if="route.name !== 'get-in-touch'" class="uppercase bg-white bg-opacity-70 backdrop-blur-sm rounded-full py-2 px-3 lg:py-3 lg:px-6 lg:font-medium flex gap-2 items-center group text-sm lg:text-[1vw]" @click="openContactForm" @mouseenter="toggleHover(true)" @mouseleave="toggleHover(false)">
          <span class="hidden lg:block">Start a Project</span>
          <span class="lg:hidden text-2xl">👋</span>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="size-5 group-hover:translate-x-1 transition-transform duration-300">
            <path fill-rule="evenodd" d="M2 10a.75.75 0 0 1 .75-.75h12.59l-2.1-1.95a.75.75 0 1 1 1.02-1.1l3.5 3.25a.75.75 0 0 1 0 1.1l-3.5 3.25a.75.75 0 1 1-1.02-1.1l2.1-1.95H2.75A.75.75 0 0 1 2 10Z" clip-rule="evenodd" />
          </svg>
        </div>
      </div>
    </div>
  </div>

  <div  class="fixed w-full bottom-20 lg:bottom-[5.5rem] z-50 left-0 px-6 rounded-full h-0 overflow-visible">
    <div id="navbar-container" class="transition-all duration-500 flex justify-center mx-auto origin-center w-full max-w-screen-lg">
      <div id="navbar-container-inner" :class="expandNav ? 'gap-2':'lg:gap-6'" class="transition-all duration-500 relative py-2 px-3 md:py-3 md:px-6 text-ellie-black flex items-center justify-center w-fit bg-gray-50 bg-opacity-70 backdrop-blur-md rounded-full overflow-hidden" @mouseenter="handleTouch('enter')" @mouseleave="handleTouch('leave')">
        <a id="navbar-logo" href="/" class="flex-shrink-0" aria-label="Ellie Motion: Creative Video Production House in Singapore">
          <!-- <MainLogo class="w-full" /> -->
          <MainLogoChar class="w-full" :color="logoColor" :active-link="activeLink" />
        </a>

          <div class="hidden md:flex items-center gap-2">
              <div
id="scroll-text-container"
              :class="[
                  {'collapsed': !expandNav},
                ]"
                class="w-[200px] masking-gradient-x overflow-hidden transition-all duration-500 origin-left flex-shrink-0"
                >
                <p id="scroll-text" class="text-xs lg:text-sm big-screen:text-base w-full whitespace-nowrap">Singapore&nbsp;Creative&nbsp;Agency&nbsp;and&nbsp;Production&nbsp;House</p>
              </div>
              <div
                id="navbar-links"
                :class="[
                  {'collapsed': !expandNav && scrolled},
                ]"
                class="relative grid grid-cols-6 w-fit transition-all duration-500"
                >
                <NuxtLink
v-for="item in links" :key="item.id" :to="item.href"
                  :class="[
                    {'visible': scrolled && expandNav && (activeLink?.id !== item.id)},
                    {'opacity-0 invisible pointer-events-none touch-none':
                      (scrolled && (activeLink?.id !== item.id) && !expandNav && !footerTouch) &&
                      (scrolled && expandNav && !footerTouch && (activeLink?.id !== item.id)) &&
                      (scrolled && !expandNav && (activeLink?.id !== item.id)) ||
                      (scrolled && !expandNav && (activeLink?.id !== item.id) && !footerTouch)
                    },
                    {'link-aktif': activeLink?.id === item.id},
                  ]"
                  class="transition-all duration-1000 font-medium whitespace-nowrap text-center text-[1.111vw] lg:text-[.8vw] hover:bg-ellie-black hover:bg-opacity-80 hover:text-white py-3 px-5 rounded-full uppercase transition-all duration-300"
                  @mouseenter="toggleHover(true)"
                  @mouseleave="toggleHover(false)"
                  @click.native="reInit"
                >
                  {{ item.name }}
                </NuxtLink>
              </div>
          </div>

        <!-- <div v-if="scrolled && !expandNav && !footerTouch || isM" class="hidden md:block">
          <NuxtLink @mouseenter="toggleHover(true)" @mouseleave="toggleHover(false)"
            :key="activeLink?.id"
            :to="activeLink?.href"
            class="w-32 inline-block font-medium whitespace-nowrap text-center text-[1.111vw] lg:text-[.8vw] hover:bg-ellie-black hover:bg-opacity-80 hover:text-white py-3 px-4 rounded-full uppercase transition-all duration-300"
          >
            {{ activeLink.name }}
          </NuxtLink>
        </div> -->

        <div class="flex-grow masking-gradient-x w-1/4 md:hidden">
          <p id="scroll-text" class="text-xs lg:text-base w-full whitespace-nowrap">Singapore&nbsp;Creative&nbsp;Agency&nbsp;and&nbsp;Production&nbsp;House</p>
        </div>

        <div class="relative">
          <button aria-label="menu" class="rounded-full flex items-center justify-center bg-ellie-blue text-white w-10 h-10 md:hidden" @click="showMenuMobile = !showMenuMobile">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="size-5">
              <path fill-rule="evenodd" d="M2 4.75A.75.75 0 0 1 2.75 4h14.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 4.75ZM2 10a.75.75 0 0 1 .75-.75h14.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 10Zm0 5.25a.75.75 0 0 1 .75-.75h14.5a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1-.75-.75Z" clip-rule="evenodd" />
            </svg>
          </button>

          <button v-if="profileOpen" aria-label="menu" class="rounded-full flex items-center justify-center bg-ellie-blue text-white w-10 h-10 md:hidden absolute top-0 left-0" @click="closeProfileModal">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="size-5">
              <path d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
            </svg>
          </button>
        </div>

      </div>
    </div>
  </div>

  <TransitionFade>
    <div v-if="showMenuMobile" class="fixed z-[52] top-0 left-0 w-full h-full">
      <MobileMenu @on-close-menu="showMenuMobile = false"/>
    </div>
  </TransitionFade>
</template>

<script setup>
import { Interactions } from '~/interactions';
const route = useRoute();
const router = useRouter();
const mainStore = useMainStore();
const navbarStore = useNavbarStore();
const { showNavbar, footerTouch, logoColor, profileOpen, scrollProgress } = storeToRefs(navbarStore);
const isMediumScreen = useMediaQuery('(min-width: 768px)');
const isL = useMediaQuery('(min-width: 1024px)');
const showMenuMobile = ref(false);
const expandNav = ref(false);
const expandNavBasedOnScroll = ref(false);

const emits = defineEmits(['openContactForm'])

const links = ref([
  {
    id: 0,
    href: '/',
    name: 'Home',
  },

  {
    id: 1,
    href: '/about',
    name: 'About',
  },

  {
    id: 2,
    href: '/works',
    name: 'Work',
  },

  {
    id: 3,
    href: '/our-services',
    name: 'Services',
  },

  {
    id: 4,
    href: '/journal',
    name: 'Journal',
  },
  
  {
    id: 5,
    href: '/get-in-touch',
    name: 'Contact',
  },
]);

const activeLink = ref(null);
const filterLinks = () => {
  const path = route.path;
  const splittedPath = path.split('/');
  let link;
  if (splittedPath.length > 2 && splittedPath[1] == 'works') {
    link = links.value.find((item) => item.href === '/works');
  } else if (splittedPath.length > 2 && splittedPath[1] == 'journal') {
    link = links.value.find((item) => item.href === '/journal');
  } else {
    link = links.value.find((item) => item.href === path);
  }
  activeLink.value = link;
};

const toggleShowSidebar = async () => {
  navbarStore.toggleSidebar();

  const body = document.getElementsByTagName('body');
  body[0].style.overflow = 'hidden';
};

const scrolled = ref(false);
const scrollHandler = (e) => {
  if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
    scrolled.value = true;
    navbarStore.scrolledActive();
  } else {
    scrolled.value = false;
    navbarStore.scrolledDisable();
  }
};

const toggleHover = (isHover, type = 'default') => {
  const payload = { isHover, type };
  mainStore.toggleTrackingMouse(payload);
};
let navbarLinksEl = null;
let navbarContainerEl, scrollTextContainer, navbarLogo, activeLinkEl, navbarContainerInner;
let navbarContainerWidth, navbarLinksWidth, scrollTextWidth, navbarLogoWidth, activeLinkWidth, navbarContainerInnerWidth;
const footerTouchTimeout = null;

let triggerFooter

onMounted(() => {
  nextTick(() => {
    if (import.meta.client) {
      navbarContainerEl = document.querySelector('#navbar-container');
      navbarContainerInner = document.querySelector('#navbar-container-inner');
      navbarLogo = document.querySelector('#navbar-logo');
      navbarLinksEl = document.querySelector('#navbar-links');
      scrollTextContainer = document.querySelector('#scroll-text-container');
      navbarContainerInner.style.clipPath = 'inset(0px calc(0%) 0px 0px round 100px)';
      scrollTextContainer.style.clipPath = 'inset(0px)';
      navbarContainerWidth = navbarContainerEl?.getBoundingClientRect();
      scrollTextWidth = scrollTextContainer?.getBoundingClientRect();
      navbarLogoWidth = navbarLogo?.getBoundingClientRect();
      navbarLinksWidth = navbarLinksEl?.getBoundingClientRect();
      activeLinkEl = document.querySelector('.link-aktif');
      activeLinkWidth = activeLinkEl?.getBoundingClientRect();
      navbarContainerInnerWidth = navbarContainerInner?.getBoundingClientRect();
    }
    window.addEventListener('resize', handleResize);
    startObserver();
    // window.onscroll = scrollHandler;
  });
});

const reInit = () => {
  if (import.meta.client) {
    navbarContainerEl = document.querySelector('#navbar-container');
    navbarContainerInner = document.querySelector('#navbar-container-inner');
    navbarLogo = document.querySelector('#navbar-logo');
    navbarLinksEl = document.querySelector('#navbar-links');
    scrollTextContainer = document.querySelector('#scroll-text-container');

    navbarContainerInner.style.clipPath = 'inset(0px calc(0%) 0px 0px round 100px)';
    scrollTextContainer.style.clipPath = 'inset(0px)';

    navbarContainerWidth = navbarContainerEl?.getBoundingClientRect();
    scrollTextWidth = scrollTextContainer?.getBoundingClientRect();
    navbarLogoWidth = navbarLogo?.getBoundingClientRect();
    navbarLinksWidth = navbarLinksEl?.getBoundingClientRect();
    navbarContainerInnerWidth = navbarContainerInner?.getBoundingClientRect();
  }
};

const handleResize = () => {
  if (window.innerWidth < 768) return;
  expandNav.value = true;
  expandNavbar();
  setTimeout(() => {
    navbarContainerWidth = navbarContainerEl?.getBoundingClientRect();
    scrollTextWidth = scrollTextContainer?.getBoundingClientRect();
    navbarLogoWidth = navbarLogo?.getBoundingClientRect();
    navbarLinksWidth = navbarLinksEl?.getBoundingClientRect();
    navbarContainerInnerWidth = navbarContainerInner?.getBoundingClientRect();
    console.log(scrolled.value);
    if (scrolled.value) {
      collapseNavbar();
    }
  }, 500);
};

const collapseNavbar = () => {
  if (window.innerWidth < 768) return;
  reInit();
  activeLinkEl = document.querySelector('.link-aktif');
  activeLinkWidth = activeLinkEl?.getBoundingClientRect();
  const hiddenElementWidth = activeLinkWidth?.width + navbarLogoWidth?.width + 48;
  navbarContainerInner.style.clipPath = `inset(0px calc(${navbarContainerInnerWidth?.width}px - ${hiddenElementWidth}px) 0px 0px round 3.5rem)`;
  navbarContainerEl.style.transform = `translateX(${(scrollTextWidth?.width / 2) + ((navbarLinksWidth?.width - activeLinkWidth?.width) / 2) + 3}px)`;
  navbarLinksEl.style.transform = `translateX(-${scrollTextWidth?.width}px)`;
  let distance = 0;
  navbarLinksEl.children.forEach((navlink, i) => {
    const rectBound = navlink?.getBoundingClientRect();
    distance += rectBound?.width;
    navlink.style.transform = `translateX(calc(-${distance - navbarLogoWidth?.width}px + 1rem + 12px))`;
  });
  expandNav.value = false;
};

const expandNavbar = () => {
  navbarContainerInner.style.clipPath = 'inset(0px calc(0%) 0px 0px round 100px)';
  navbarLinksEl.style.transform = 'translateX(0)';
  navbarContainerEl.style.transform = 'translateX(0)';
  navbarLinksEl.children.forEach((navlink, i) => {
    navlink.style.transform = 'translateX(0)';
  });
};

const startObserver = () => {
  if (import.meta.client) {
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: [0.0, 0.05, 0.1, 0.15, 0.2, 0.25, 0.3, 0.35, 0.4, 0.45, 0.5, 0.55, 0.6, 0.65, 0.7, 0.75, 0.8, 0.85, 0.9, 0.95, 1.0],
    };

    const filter = document.querySelector('#navbar-trigger');
    const filterCallback = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          scrolled.value = false;
          if (expandNav.value) expandNavbar();
        } else {
          scrolled.value = true;
        }
      });
    };
    const filterObserver = new IntersectionObserver(filterCallback, options);
    filterObserver.observe(filter);

    const footerTrigger = document.querySelector('#triggerFooter');
    let fTo = null
    const footerTriggerCallback = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (fTo) clearTimeout(fTo)
          fTo = setTimeout(() => {
            expandNav.value = true;
            clearTimeout(fTo)
          }, 300)
        } else {
          if (fTo) clearTimeout(fTo)
          fTo = setTimeout(() => {
            expandNav.value = false;
            clearTimeout(fTo)
          }, 300)
        }
      });
    };
    const footerTriggerObserver = new IntersectionObserver(footerTriggerCallback, options);
    footerTriggerObserver.observe(footerTrigger);
  }
};

const handleTouch = (event) => {
  if (!scrolled.value) {
    return;
  }
  if (footerTouch.value) return expandNav.value = true;
  if (event === 'enter') {
    expandNav.value = true;
  } else if (event === 'leave') {
    expandNav.value = false;
  }
};

watch(() => scrolled.value, (val) => {
  if (val) {
    expandNav.value = false;
    setTimeout(() => {
      collapseNavbar();
    }, 500);
  } else {
    expandNav.value = true;
  }
});

watch(() => expandNav.value, (val) => {
  if (!val) {
    collapseNavbar();
  } else {
    expandNavbar();
  }
});

// watch(() => footerTouch.value, (val) => {
//   if (!val) {
//     footerTouchTimeout = setTimeout(() => {
//       expandNav.value = false;
//       clearTimeout(footerTouchTimeout);
//     }, 0);
//   } else {
//     footerTouchTimeout = setTimeout(() => {
//       expandNav.value = true;
//       clearTimeout(footerTouchTimeout);
//     }, 0);
//   }
// });

watch(() => router.currentRoute.value,
  val => {
    navbarStore.showNavbarValue();
  },
  { immediate: true },
);

watch(() => route.path,
  () => {
    filterLinks();
    if (navbarLinksEl && navbarLinksEl.length > 0) {
      navbarLinksEl.children.forEach((navlink, i) => {
        navlink.style.transform = 'translateX(0)';
      });
    }
  },
  { immediate: true },
);

const closeProfileModal = () => {
  navbarStore.toggleProfile(false)
} 

watch(() => scrollProgress.value, (val) => {
  if (val >= 0.99) {
    expandNavBasedOnScroll.value = true;
    // expandNav.value = true;
    // scrolled.value = false;
  }
});

const openContactForm = () => {
  emits('openContactForm')
}
</script>

<style lang="scss" scoped>
.router-link-active.router-link-exact-active{
  @apply bg-ellie-blue text-white;
}
#navbar-container {
  // box-shadow: inset 0px 0px 0px 1px #ccc;
}
.link-aktif {
  z-index: 10;
  background-color: rgb(50 80 205);
  color: white;
}
#navbar-links.collapsed {
  a:not(.link-aktif) {
    opacity: 0;
    pointer-events: none;
    touch-action: none;
  }
}
#scroll-text-container.collapsed {
  opacity: 0;
}
</style>
